import { render, staticRenderFns } from "./componentPermission.vue?vue&type=template&id=020ed026&scoped=true&"
import script from "./componentPermission.vue?vue&type=script&lang=ts&"
export * from "./componentPermission.vue?vue&type=script&lang=ts&"
import style0 from "./componentPermission.vue?vue&type=style&index=0&id=020ed026&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "020ed026",
  null
  
)

export default component.exports